import { ProjectRenderer } from '../ProjectRenderer';
import { Mouse } from './Mouse';

export class CursorHandler {
	constructor(private renderer: ProjectRenderer, private mouse: Mouse) {}

	setCursorType() {}
}
